import { apiAction } from "../models/requests";

const appendTokenName = (data) => {
    return data;
};

export function getAdminUsers() {
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }  
    let data = {};
    appendTokenName(data);
    return apiAction({
        types: ["GET_ADMIN_USERS_REQUESTED", "GET_ADMIN_USERS_SUCCESS", "GET_ADMIN_USERS_FAILED"],
        method: "POST",
        path: "admin/get_users",
        body: data
    });
}

export function getUsersId(userId) {
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }   
    let data = {};
    data.target_user = {"user_id": userId}; 
    appendTokenName(data);
    return apiAction({
        types: ["GET_USER_ID_REQUESTED", "GET_USER_ID_SUCCESS", "GET_USER_ID_FAILED"],
        method: "POST",
        path: "admin/get_user",
        body: data
    });
}

export function createUser(userData) {
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {};
    data.target_user = userData;   
    appendTokenName(data); 
    return apiAction({
        types: ["CREATE_USER_REQUESTED", "CREATE_USER_SUCCESS", "CREATE_USER_FAILED"],
        method: "POST",
        path: "admin/create_user",
        body: data
    });
}

export function updateUser(userData) {
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {};
    data.target_user = userData;
    appendTokenName(data);
    return apiAction({
        types: ["UPDATE_USER_REQUESTED", "UPDATE_USER_SUCCESS", "UPDATE_USER_FAILED"],
        method: "POST",
        path: "admin/update_user",
        body: data
    });
}

export function resetPasswordFunc(userData) {
    let data = {};
    data.target_user = userData;
    appendTokenName(data);
    return apiAction({
        types: ["RESET_PASSWORD_REQUESTED", "RESET_PASSWORD_SUCCESS", "RESET_PASSWORD_FAILED"],
        method: "POST",
        path: "admin/update_user",
        body: data
    });
}

export function deleteUser(userId) {
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {};
    data.target_user = {"user_id": userId};    
    appendTokenName(data);
    return apiAction({
        types: ["DELETE_USER_REQUESTED", "DELETE_USER_SUCCESS", "DELETE_USER_FAILED"],
        method: "POST",
        path: "admin/delete_user",
        body: data
    });
}

export function deleteUserKasm(kasmId) {
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {};
    data.kasm_id = kasmId;
    appendTokenName(data);
    return apiAction({
        types: ["DELETE_USER_KASM_REQUESTED", "DELETE_USER_KASM_SUCCESS", "DELETE_USER_KASM_FAILED"],
        method: "POST",
        path: "destroy_kasm",
        body: data
    });
}

export function getAdminUsageDump(user_id) {
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {"user_id": user_id};
    appendTokenName(data);
    return apiAction({
        types: ["GET_USAGE_DUMP_REQUESTED", "GET_USAGE_DUMP_SUCCESS", "GET_USAGE_DUMP_FAILED"],
        method: "POST",
        path: "admin/get_user_usage_dump",
        body: data
    });
}


// WEBPACK FOOTER //
// ./src/actions/actionAdminUser.js